/**
 * Statická konfigurace webu — ověřené identifikační a kontaktní údaje.
 * Zdroj: veřejně dostupné údaje společnosti (dane-a-ucetnictvi.eu).
 * Položky označené `verified: false` je nutné před spuštěním potvrdit klientem.
 */
export const site = {
  name: "GP tax consulting s.r.o.",
  legalName: "GP tax consulting s.r.o.",
  shortName: "GP tax consulting",
  tagline: "Daňové poradenství, účetnictví a mzdy — Opava",
  description:
    "Účetní a daňová kancelář z Opavy. Vedení účetnictví a daňové evidence, daňové poradenství, zpracování daňových přiznání a mezd pro podnikatele, OSVČ a malé i střední firmy.",
  url: process.env.NEXT_PUBLIC_SITE_URL ?? "https://www.dane-a-ucetnictvi.eu",
  locale: "cs_CZ",
  founded: 1995,
  // Kontakt
  phone: "+420 553 612 851",
  mobile: "+420 777 612 851",
  email: "info@dane-a-ucetnictvi.eu", // TODO(klient): potvrdit oficiální e-mail
  emailVerified: false,
  address: {
    street: "Sadová 121/4",
    city: "746 01 Opava",
    district: "Předměstí",
    country: "Česká republika",
    countryCode: "CZ",
  },
  officeHours: "Po–Pá 8:00–14:00",
  // Identifikační údaje
  ico: "01988875",
  dic: "CZ01988875",
  legalForm: "Společnost s ručením omezeným",
  registry: "Spisová značka C 57058 vedená u Krajského soudu v Ostravě",
  bankAccount: "2400465455/2010",
  dataBox: "59iy7m8",
  // Mapa
  mapUrl:
    "https://www.google.com/maps/search/?api=1&query=Sadov%C3%A1+121%2F4%2C+746+01+Opava",
} as const;

export type SiteConfig = typeof site;
